var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurriculum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.92,
    height: 106.15,
    viewBox: "0 0 84.92 106.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "curriculum",
    transform: "translate(-51.2)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2010",
    "data-name": "Group 2010",
    transform: "translate(114.89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2009",
    "data-name": "Group 2009"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M358.4,0V21.23h21.23Z",
    transform: "translate(-358.4)",
    fill: "#a9afbc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2012",
    "data-name": "Group 2012",
    transform: "translate(51.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2011",
    "data-name": "Group 2011",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M104.275,31.845V0H56.507A5.014,5.014,0,0,0,51.2,5.308v95.535a5.014,5.014,0,0,0,5.307,5.308h74.305a5.014,5.014,0,0,0,5.307-5.308v-69ZM77.738,10.615A10.615,10.615,0,1,1,67.122,21.23,10.646,10.646,0,0,1,77.738,10.615ZM61.815,45.645c0-11.146,31.845-11.146,31.845,0v7.431H61.815Zm47.767,49.89H67.122a5.307,5.307,0,0,1,0-10.615h42.46a5.014,5.014,0,0,1,5.308,5.308A5.319,5.319,0,0,1,109.582,95.535ZM120.2,74.305H67.122a5.308,5.308,0,0,1,0-10.615H120.2A5.014,5.014,0,0,1,125.505,69,5.319,5.319,0,0,1,120.2,74.305Z",
    transform: "translate(-51.2)",
    fill: "#a9afbc"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurriculum);
export default __webpack_public_path__ + "static/media/curriculum.eabe7f30a1f240b23e648646878aec18.svg";
export { ForwardRef as ReactComponent };